import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../../user/user.service";
import {InfoService} from "../../info/info.service";

@Component({
  selector: 'yz-default-index',
  templateUrl: './yz-default-index.component.html',
  styleUrls: ['./yz-default-index.component.less']
})
export class YzDefaultIndexComponent implements OnInit {
  logoUrl: string = '';
  title: string = '';
  menus: any[] = [];
  color = '';
  colorDodge = '';
  constructor(private userService: UserService,
              private activatedRoute: ActivatedRoute,
              private infoService: InfoService,
              private router: Router) {
  }

  ngOnInit(): void {
    const menus = this.userService.get().menu || [];
    this.activatedRoute.data.subscribe(res => {
      const systemCode = res.systemCode;

      const mobileApp = this.userService.findMenuBySystemCode(menus, 'mobileApp');
      const app = this.userService.findMenuBySystemCode(mobileApp.children, systemCode);
      if (app) {
        this.title = app.text;
        const groups = app.children || [];
        this.menus = groups.flatMap(group => group.children || []);
      }
      // 用传过来的标题覆盖
      if (res.title) {
        this.title = res.title;
      }
    })
    this.infoService.getSystemInfo().subscribe(res => {
      this.logoUrl = res.maxLogoUrl;
      if (res.clientEnd && res.clientEnd.color) {
        this.color = res.clientEnd.color;
        this.colorDodge = this.colorRgba(this.color, 0.71);
      }
    })

  }


  routerJump(item: any) {
    if (item.link) {
      this.router.navigateByUrl(item.link);
    } else if (item.appUrl) {
      window.location.href = item.appUrl;
    }
  }

  /**
   * 十六进制颜色值减淡
   * @param value 颜色值
   * @param transparency 透明度<=1
   */
  colorRgba(value, transparency) {
    // 16进制颜色值的正则
    const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    // 把颜色值变成小写
    let color = value.toLowerCase();
    if (reg.test(color)) {
      // 如果只有三位的值，需变成六位，如：#fff => #ffffff
      if (color.length === 4) {
        let colorNew = "#";
        for (let i = 1; i < 4; i += 1) {
          colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
        }
        color = colorNew;
      }
      // 处理六位的颜色值，转为RGB
      const colorChange = [];
      for (let i = 1; i < 7; i += 2) {
        colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
      }
      return "rgba(" + colorChange.join(",") + "," + transparency + ")";
    } else {
      return color;
    }
  }

}
